interface TreatmentMedicineOpenDateModelProps {
  openDate: string;
}

export class TreatmentMedicineOpenDateModel {
  private readonly openDate: string;

  constructor(private readonly props: TreatmentMedicineOpenDateModelProps) {
    this.openDate = props.openDate;
  }

  getOpenDate() {
    return this.openDate;
  }
}
